import Validator from "validatorjs";
import { messages as defaultMessages } from "./messages";
export const validator = {
    /**
     * Checks if the given data is valid against the given rules.
     *
     * @param {T} data The data to validate.
     * @param {Rules} rules The rules to validate against.
     * @returns {boolean} Whether the data is valid.
     */
    isValid: (data, rules) => {
        const validation = new Validator(data, rules);
        return !!validation.passes();
    },
    /**
     * Validates the given data against the given rules and returns all the errors.
     *
     * @param {T} data The data to validate.
     * @param {Rules} rules The rules to validate against.
     * @param {ErrorMessages} [messages={}] The custom error messages.
     * @returns {object} The validation errors.
     */
    validateAll: (data, rules, messages = {}) => {
        const validation = new Validator(data, rules, {
            ...defaultMessages,
            ...messages,
        });
        // Transform and return errors
        if (validation.check() === false) {
            return Object.keys(validation.errors.all()).reduce((errors, key) => {
                if (validation.errors.has(key)) {
                    errors[key] = validation.errors.first(key);
                }
                return errors;
            }, {});
        }
        else {
            return {};
        }
    },
};
